import { SharedComponent } from './shared.component';
import { Routes, RouterModule } from '@angular/router';
const sharedRoutes: Routes = [
    {
      path: 'view',
      component: SharedComponent,
      children: [
        { path: '', redirectTo: '/view/summary', pathMatch: 'full' },
        {
          path: 'summary',
          loadChildren: () => import('./shared-pages/shared-component-pages.module').then((x) => x.SharedComponentPagesModule),
        }
      ],
    },
  ];
  
  export const SHARED_ROUTES = RouterModule.forChild(sharedRoutes);